import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-601">
      <div className="absolute inset-0 bg-sage/80 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-602" />

      <div className="relative bg-cream rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden transform transition-all" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-603">
        <div className="flex items-center justify-between p-6 border-b border-sage/10 bg-white" data-id="element-604">
          <h2 id="modal-title" className="text-2xl font-serif font-bold text-sage" data-id="element-605">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-sage/50 hover:text-sage hover:bg-sage/5 rounded-full transition-colors" aria-label="Cerrar" data-id="element-606">
            <X className="w-6 h-6" data-id="element-607" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1 text-sage/80 prose prose-sage max-w-none" data-id="element-608">
          {children}
        </div>
      </div>
    </div>;
}